/**
 * 应用 Provider 组合 - 组合所有 Provider
 */

import React, { ReactNode } from 'react';
import { AuthProvider } from './AuthProvider';
import { DataProvider } from './DataProvider';

interface AppProvidersProps {
  children: ReactNode;
}

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <AuthProvider>
      <DataProvider>{children}</DataProvider>
    </AuthProvider>
  );
};
